/**
 * @generated SignedSource<<e0d0a74ec2633f7024d82ce99e7823b3>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PhotosSearchBrowseFacetFilter_photos$data = {
  readonly facets: {
    readonly designProjectTypeFacet: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetBlock_facets">;
    } | null> | null;
    readonly imageCreatorFacets: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetBlock_facets">;
    } | null> | null;
    readonly imageRoomTypeFacet: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetBlock_facets">;
    } | null> | null;
    readonly imageStyleFacet: ReadonlyArray<{
      readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetBlock_facets">;
    } | null> | null;
  } | null;
  readonly totalResults: number | null;
  readonly " $fragmentType": "PhotosSearchBrowseFacetFilter_photos";
};
export type PhotosSearchBrowseFacetFilter_photos$key = {
  readonly " $data"?: PhotosSearchBrowseFacetFilter_photos$data;
  readonly " $fragmentSpreads": FragmentRefs<"PhotosSearchBrowseFacetFilter_photos">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "PhotosSearchBrowseFacetBlock_facets"
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PhotosSearchBrowseFacetFilter_photos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "totalResults",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PhotosSearchBrowseFacets",
      "kind": "LinkedField",
      "name": "facets",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "FacetValueType",
          "kind": "LinkedField",
          "name": "imageStyleFacet",
          "plural": true,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FacetValueType",
          "kind": "LinkedField",
          "name": "imageRoomTypeFacet",
          "plural": true,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FacetValueType",
          "kind": "LinkedField",
          "name": "designProjectTypeFacet",
          "plural": true,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "FacetValueType",
          "kind": "LinkedField",
          "name": "imageCreatorFacets",
          "plural": true,
          "selections": (v0/*:: as any*/),
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowseQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "e26a8026c1b9418952074d93fcddd775";

export default node;
